const ORDERED_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const getOrderedMonths = (): string[] => {
  return ORDERED_MONTHS;
};

export const getMonthIndex = (value: string): number => {
  const lower = value.toLowerCase();
  return ORDERED_MONTHS.findIndex(
    (m) =>
      m.toLowerCase() === lower || m.substring(0, 3).toLowerCase() === lower,
  );
};

export const mapMonthNumberToString = (monthNumber: string): string => {
  const index = Number(monthNumber) - 1;
  if (index >= 0 && index < ORDERED_MONTHS.length) {
    return ORDERED_MONTHS[index];
  }
  return monthNumber;
};

export default getOrderedMonths;
